import { useEffect, useRef, useState } from "react";
import SuppliesApi from "../../../../API/shipment/supplies-api";
import { Column, Row, WhiteBlock } from "../../../../components/Basic/Blocks";
import { Input } from "../../../../components/Basic/Inputs";
import { HeaderTitle, Table, TableHeader } from "../../../../components/Basic/Table";
import CardLine from "./cardLine";
import styles from './styles.module.scss';



function SearchCardsBlock({
  activeBox,
  shop,
  providerId,
  skladName,
  printSticker = () => _
}) {


  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
      htmlElRef.current && htmlElRef.current.select();
    };

    return [htmlElRef, setFocus];
  };

  const [inputRef, setInputFocus] = useFocus();

  const [cards, setCards] = useState([]);
  const [search, setSearch] = useState('');
  const [address, setAddress] = useState(undefined);
  const [limit, setLimit] = useState(50);
  const [isProductFound, setIsProductFound] = useState(null);



  const getCards = async () => {
    const { cards, isProductFound } = await SuppliesApi.getCards({
      data: {
        search,
        shop,
        skladName,
        providerId,
        address
      }
    })
    setCards(cards)
    setIsProductFound(isProductFound)
  }

  useEffect(() => {
    if (!shop) return
    getCards();
  }, [search, shop, providerId, address]);



  return (
    <Column style={{ maxWidth: 'fit-content', flexGrow: '1', flexBasis: '0', marginLeft: '30px' }}>
      <WhiteBlock className={styles.search_block}>
        <Row className={styles.row_input}>
          <Input
            value={search}
            onClickEnter={(v) => setSearch(v)}
            onBlur={(v) => setSearch(v)}
            label="Поиск карточек"
            ref={inputRef}
          />
        </Row>
        <Row style={{ height: '60px' }}>
          <Row style={{ paddingTop: '35px', width: '250px', color: '#000000c2' }}>Текущий короб: {activeBox}</Row>
          {/* <Input
            value={address}
            onBlur={(v) => setAddress(v)}
            onClickEnter={(v) => setAddress(v)}
            width="140px"
            label="Место на складе"
          /> */}
        </Row>

      </WhiteBlock>
      <Table style={{ overflow: 'auto', minWidth: '0px' }}>
        <TableHeader whiteHeader>
          <HeaderTitle style={{fontSize: '10px'}} width={'60px'}>
            Площ.
          </HeaderTitle>
          <HeaderTitle width={'70px'}>
            Баркод
          </HeaderTitle>
          <HeaderTitle width={'50px'}>
            Кол
          </HeaderTitle>
          <HeaderTitle centerText={true} width={'280px'}>
            Наименование
          </HeaderTitle>
          {/* <HeaderTitle centerText={true} width={'100px'}>Остаток на складе</HeaderTitle> */}
          <HeaderTitle centerText={true} width={'100px'}>
            Кол-во в карточке
          </HeaderTitle>
          {/* <HeaderTitle centerText={true} width={'190px'}>
            Артикул
          </HeaderTitle> */}
          {/* <HeaderTitle centerText={true} width={'100px'}>
            Кол-во продаж
          </HeaderTitle>
          <HeaderTitle centerText={true} width={'100px'}>
            Цена продажи
          </HeaderTitle> */}
          <HeaderTitle centerText={true} width={'130px'}>
            Sku
          </HeaderTitle>
        </TableHeader>

        {isProductFound === false ?
          <Row style={{ padding: '20px', color: '#2f2f2f9d', fontSize: '20px' }}>
            Товар на складе не найден
          </Row> :
          (isProductFound === true && cards.length === 0) ?
            <Row style={{ padding: '20px', color: '#2f2f2f9d', fontSize: '20px' }}>
              Не существует карточек, либо остаток нулевой
            </Row>
            :
            cards.map((card, i) => {
              return (
                <CardLine
                  onPrint={(...p) => {
                    printSticker(...p)
                    setInputFocus()
                  }}

                  card={card}
                />

              );
            })}
      </Table>
    </Column>
  )

}

export default SearchCardsBlock